import{on}from"./on";export const listenResize=(handler,el)=>on(el||window,"resize",handler);export default listenResize;